import React, { useState, useEffect } from 'react';
import TR from './../../Trans';
import timeoutsStore from './../../stores/timeouts';

const songBookTimeSecs = 120;
const homeUseTimeSecs = 5;

function BottomBarPlayer(props) {

  const [isAnimating, setIsAnimating] = useState(false);
  const [songBook, setSongBook] = useState(true);
  const [homeUse, setHomeUse] = useState(false);

  const timeoutSongBook = () => { 
    if (timeoutsStore.getState().timerBottomSongbook) {
      clearInterval(timeoutsStore.getState().timerBottomSongbook);
    }
    let timer = setTimeout(function () {
      setSongBook(false);
      if (props.isCustomer) {
        setHomeUse(true);
      }
      timeoutHomeUse();
    }, songBookTimeSecs * 1000);
    timeoutsStore.getState().setTimerBottomSongbook(timer);
  };

  const timeoutHomeUse = () => { 
    if (timeoutsStore.getState().timerBottomHomeUse) {
      clearInterval(timeoutsStore.getState().timerBottomHomeUse);
    }
    let timer = setTimeout(function () {
      setSongBook(true);
      setHomeUse(false);
      timeoutSongBook();
    }, homeUseTimeSecs * 1000);
    timeoutsStore.getState().setTimerBottomHomeUse(timer);
  };

  const beginTimer = () => { 
    if (timeoutsStore.getState().timerBottomSongbook) {
      clearInterval(timeoutsStore.getState().timerBottomSongbook);
    }
    if (timeoutsStore.getState().timerBottomHomeUse) {
      clearInterval(timeoutsStore.getState().timerBottomHomeUse);
    }
    setSongBook(true);
    setHomeUse(false);
    timeoutSongBook();
    setIsAnimating(true);
  };

  useEffect(function () {
    if (!isAnimating) {
      beginTimer();
    }
  }, []);

  useEffect(function () {
    beginTimer();
  }, [props.isSongBookEnabled]);

  useEffect(function () {
    beginTimer();
  }, [props.isCustomer]);

  const render = () => { 
    if (isAnimating) {
      return <div>
        <p className="fadeinoutbottom" style={{ display: (props.isSongBookEnabled && songBook) ? "block" : "none", textAlign: "center", animation: "fade-in 0.2s ease-in forwards, fade-out 0.2s " + (songBookTimeSecs - 0.2) + "s ease-out forwards" }}>
          <span>
            <b>{TR.cm_choose_your_song}:</b> <span className="muvika-white">{props.songBookUrl}</span> <b>{TR.cm_code}:</b> <span className="muvika-white">{props.songBookStr}</span>
          </span>
        </p>
        <p className="fadeinoutbottom" style={{ display: homeUse ? "block" : "none", textAlign: "center", animation: "fade-in 0.2s ease-in forwards, fade-out 0.2s 4.8s ease-out forwards" }}>
          <span>
            {TR.cm_karaoke_for_home_use_only}
          </span>
        </p>
      </div>;
    }
  };

  return (
    <div style={{ height: "5vh", fontSize: "3vh !important"}}>
      {render()}
    </div>
  );
}

export default BottomBarPlayer;